import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useSelector } from "react-redux";
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { isEmpty, CellType } from '../../modules/appLibrary';

//--------------------------------------------------------
//  関連ファイルRender
//
//  type:0:filename 1:delete 2:check
//  click: filedouwnload or fileDelete
//--------------------------------------------------------
export default function HinbanRenderFile(props) {
    const formstatus = useSelector(state => state.form.status);
    const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
    const [checkvalue, setcheckvalue] = useState('0');
    const sectionLock = !!props.sectionLock;

    useEffect(() => {
        if (props.type === 2) {
            if (props.data.kind === "1" || props.data.kind === 1)
                setcheckvalue("1");
            else
                setcheckvalue("0");
        }
    }, []);

    function checkchange(e) {
        if (sectionLock) return;
        let newvalue;
        if (checkvalue === "1" || checkvalue === 1) {
            newvalue ="0";
        } else {
            newvalue ="1";
        }
        setcheckvalue(newvalue);
        if (!isEmpty(props.checkchanged)) {
            props.checkchanged(props, newvalue);
        }
    }
    function RenderBody() {
        if (props.type === 0) {
            return (
                <div style={{ position: 'rerative' }}>
                    {cellValue}
                    {formstatus !== 'ENTRY FORM' || sectionLock ? null :
                        <div style={{ position: 'absolute', top: 2, right: 5, cursor: 'pointer' }} onClick={() => props.click(props)}>
                            <IconButton size="small">
                                <Icon>file_download</Icon>
                            </IconButton>
                        </div>
                    }
                </div>
            );
        }
        if (props.type === 1) {
            return (
                <IconButton size="small" onClick={()=>props.click(props)} disabled={sectionLock}>
                    <Icon>delete_outline</Icon>
                </IconButton>
            );
        }
        if (props.type === 2) {
            return (
                <IconButton
                    size="small" onClick={checkchange} disabled={sectionLock}>
                    {checkvalue === "1" || checkvalue === 1 ?
                        <Icon>check_box</Icon>
                        :
                        <Icon>check_box_outline_blank</Icon>
                    }
                </IconButton>
            );
        }
        return null;
    }
    return (
        <RenderBody />
    );
}
